import { render, staticRenderFns } from "./MapPolygon.component.vue?vue&type=template&id=1151982c&scoped=true"
import script from "./MapPolygon.component.vue?vue&type=script&lang=ts"
export * from "./MapPolygon.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1151982c",
  null
  
)

export default component.exports